import React from 'react';
import {
  Box,
  Grid,
  Table,
  TableBody,
  TableContainer,
  TablePagination,
  Pagination,
  Stack,
  useMediaQuery,
} from '@mui/material';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import ManIcon from '@mui/icons-material/Man';
import {
  BackdropLoading,
  BookButton,
  BookSearchDropDownField,
  BookSearchField,
  CardComponent,
} from '../../components';

import { WHITE_COLOR, GREY_COLOR } from '../../styles/constants';
import { TableHeadComponent, TableRows } from '../../components';
import BookChapterModal from '../modals/bookChapter';
import { useTheme } from '@mui/material/styles';
import { useBookChapter } from './hooks/bookChapter.hook';
import { useStyles } from './bookChapter.style';
import AddIcon from '@mui/icons-material/Add';

const BookChapterTable = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const {
    BookChapterData,
    languageData,
    bookData,
    action,
    BookChapterCount,
    open,
    setOpen,
    singleBookChapter,
    tableCells,
    actionsIcons,
    limit,
    page,
    isLoading,
    searchKey,
    handleGetBookChapterData,
    handleAdd,
    handleActionClick,
    handleChangePage,
    calculatePagesCount,
    handleChangeRowsPerPage,
    handleBookChapterSearch,
    handleDropDown
  } = useBookChapter();

  const dataIcons = [
    { id: 'bookId', title: 'Book Name', gridTitleSize: 5, gridSize: 6 },
    { id: 'chapterName', title: 'Chapter Name', gridTitleSize: 5, gridSize: 6 },
    {
      id: 'chapterNo',
      title: 'Chapter No',
      gridTitleSize: 5,
      gridSize: 6,
      icon: (
        <ManIcon
          sx={{
            fontSize: '19px',
            marginLeft: '2px',
          }}
        />
      ),
    },
    {
      id: 'url',
      title: 'URL',
      gridTitleSize: 5,
      gridSize: 6,
      icon: (
        <ContactPhoneIcon
          sx={{
            fontSize: '19px',
            marginLeft: '2px',
          }}
        />
      ),
    },
  ];

  return (
    <Box component='div' sx={isMobile && { paddingBottom: 10 }}>
      {open && (
        <BookChapterModal
          tableCells={tableCells}
          open={open}
          setOpen={setOpen}
          singleBookChapter={singleBookChapter}
          action={action}
          handleGetBookChapterData={handleGetBookChapterData}
          languageData={languageData}
          bookData={bookData}
        />
      )}
      <BackdropLoading open={isLoading} />
      <Box
        component='div'
        sx={{
          width: '100%',
          position: isMobile && 'sticky',
          top: isMobile && '7rem',
          zIndex: isMobile && 1000,
          background: 'white',
        }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={2} lg={2}>
                <BookSearchDropDownField
                      type='select'
                      searchKey={searchKey}
                      handleDropDown={handleDropDown}
                      sx={{ width: isMobile ? '100%' : '100%' }}
                      selectOptions={[
                          { value: 'chapterName', text: 'Chapter Name' },
                          { value: 'chapterNo', text: 'Chapter No' },
                          { value: 'url', text: 'URL' },
                      ]}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={8} lg={8}>
            <BookSearchField
              type='text'
              handleSearch={handleBookChapterSearch}
              sx={{ width: isMobile ? '100%' : '50%' }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={2} lg={2}>
            <BookButton
              onSubmit={handleAdd}
              title='Add Chapter'
              type='primary'
              variant='contained'
              icon={<AddIcon />}
            />
          </Grid>
        </Grid>
      </Box>
      {isMobile ? (
        <>
          {BookChapterData &&
            Object.keys(BookChapterData).length > 0 &&
            BookChapterData?.map(row => (
              <CardComponent
                key={'BookChapterDara' + row.id}
                sx={{
                  background: GREY_COLOR.GHOSTWHITE,
                  width: '97%',
                  margin: '20px 5px 5px 5px',
                }}
                classBorder={
                  Object.keys(row['measurement']).length > 0
                    ? classes.statusCompleted
                    : classes.statusPending
                }
                titleStyle={classes.titleStyle}
                uniqueKey='-BookChapterCrud'
                rows={row}
                dataIcons={dataIcons}
                tableCells={tableCells}
                actionsIcons={actionsIcons}
                handleActionClick={handleActionClick}
              />
            ))}
          <Stack className={classes.paginationStyle} spacing={2}>
            <Pagination
              count={calculatePagesCount(limit, BookChapterCount)}
              page={page + 1}
              onChange={(event, newPage) => handleChangePage(true, newPage)}
              color='primary'
            />
          </Stack>
        </>
      ) : (
        <>
          <TableContainer
            sx={{
              width: '100%',
              background: WHITE_COLOR,
            }}
          >
            <Table sx={{ minWidth: '100%' }} aria-label='simple table'>
              <TableHeadComponent tableCells={tableCells} />
              <TableBody>
                <TableRows
                  uniqueKey='-BookChapterCrud'
                  tableCells={tableCells}
                  rows={BookChapterData}
                  actionsIcons={actionsIcons}
                  handleActionClick={handleActionClick}
                />
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            component='div'
            count={BookChapterCount}
            page={page}
            onPageChange={(event, newPage) => handleChangePage(false, newPage)}
            rowsPerPage={limit}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[25, 50, 100, 250, 500, 750, 1000]}
          />
        </>
      )}
    </Box>
  );
};
export default BookChapterTable;
